import { takeEvery } from 'redux-saga/effects';

import * as payoutActions from 'store/modules/payouts';
import { updateBusinessAccount } from './utils';

export default function* listenUpdateBusinessAccount() {
  yield takeEvery(payoutActions.updateBusinessAccount.toString(), updateBusinessAccount);
}
